var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationTracker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_240_1",
    "data-name": "Component 240 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_464",
    "data-name": "Ellipse 464",
    cx: 19,
    cy: 19,
    r: 19,
    fill: "rgba(12,102,228,0.1)",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49965",
    "data-name": "Group 49965",
    transform: "translate(-13312.295 -14138.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49965-2",
    "data-name": "Group 49965"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138359",
    "data-name": "Rectangle 138359",
    width: 20,
    height: 20,
    rx: 2.377,
    transform: "translate(13321.25 14147.75)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_614",
    "data-name": "Line 614",
    y2: 2.5,
    transform: "translate(13331.25 14150.523)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_615",
    "data-name": "Line 615",
    y2: 2.5,
    transform: "translate(13331.25 14162.057)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_616",
    "data-name": "Line 616",
    x1: 2.5,
    transform: "translate(13335.557 14157.75)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_617",
    "data-name": "Line 617",
    x1: 2.5,
    transform: "translate(13324.023 14157.75)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationTracker);
export default __webpack_public_path__ + "static/media/application-tracker.39b1201b4fc3b3cb8c3890cb3a530ab8.svg";
export { ForwardRef as ReactComponent };